import firebase from 'firebase';
import { AppDispatch } from '../../store';
import { COLLECTIONS } from '../../constants/data';
import { serializeBillSnap } from './bill.service';
import { billUpdated, billListenerError, resetBill } from './bill.slice';

let unsubscribeBill: firebase.Unsubscribe | null = null;
let activeBillKey: string | null = null;

export const syncBillListener = (
  restaurantId: string | null,
  sessionId: string | null,
  dispatch: AppDispatch
) => {
  const key = restaurantId && sessionId ? `${restaurantId}::${sessionId}` : null;
  if (key === activeBillKey) return;

  if (unsubscribeBill) { unsubscribeBill(); unsubscribeBill = null; }

  activeBillKey = key;

  if (!key || !restaurantId || !sessionId) {
    dispatch(resetBill());
    return;
  }

  unsubscribeBill = firebase.firestore()
    .collection(COLLECTIONS.restaurants).doc(restaurantId)
    .collection(COLLECTIONS.dineInTableSitting).doc(sessionId)
    .collection(COLLECTIONS.billLog)
    .onSnapshot(
      (snapshot) => {
        dispatch(billUpdated(snapshot.docs.map(serializeBillSnap)));
      },
      (error) => {
        dispatch(billListenerError(error.message));
        activeBillKey = null;
        unsubscribeBill = null;
      }
    );
};